import { unsafeCSS, LitElement, css, supportsAdoptingStyleSheets, adoptStyles } from "lit";
import { withEventEmitter } from "../decorators/withEventEmitter.js";
import tailwindStyle from "../styles/tailwind.global.css.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
const tailwindStylesheet = unsafeCSS(tailwindStyle);
const SKELETON = {
  display: "--dsf-skeleton-display",
  position: "--dsf-skeleton-display"
};
let BaseComponent = class extends LitElement {
  connectedCallback() {
    super.connectedCallback();
    const root = this.shadowRoot;
    if (root) {
      if (supportsAdoptingStyleSheets) {
        adoptStyles(root, [...root.adoptedStyleSheets, tailwindStylesheet]);
      } else {
        adoptStyles(root, [tailwindStylesheet]);
      }
    }
  }
};
BaseComponent.shadowRootOptions = {
  ...LitElement.shadowRootOptions,
  delegatesFocus: true
};
BaseComponent.styles = [
  css`
      :host {
        display: flex;
        box-sizing: border-box;
      }

      ::-webkit-scrollbar {
        width: calc(1.4 * var(--dsf-base-size));
      }

      ::-webkit-scrollbar-track {
        background: rgb(var(--dsf-color-neutral-0));
      }

      ::-webkit-scrollbar-thumb {
        background: rgb(var(--dsf-color-neutral-100));
        border-radius: 9999px;
        border: calc(0.4 * var(--dsf-base-size)) solid rgb(var(--dsf-color-neutral-0));
      }

      ::-webkit-scrollbar-thumb:hover {
        background: rgb(var(--dsf-color-neutral-200));
      }

      @keyframes skeleton-loading {
        0% {
          background-color: rgb(var(--dsf-color-neutral-100));
          outline-color: rgb(var(--dsf-color-neutral-100));
        }

        100% {
          background-color: rgb(var(--dsf-color-neutral-200));
          outline-color: rgb(var(--dsf-color-neutral-200));
        }
      }

      [data-skeleton] {
        position: var(${unsafeCSS(SKELETON.position)});
      }

      [data-skeleton]::before {
        content: '';
        display: var(${unsafeCSS(SKELETON.display)}, none);
        position: absolute;
        inset: -1px;
        z-index: var(--dsf-z-index-skeleton);
        border-radius: 2px;
        animation: skeleton-loading 1s linear infinite alternate;
        cursor: default;
      }
    `
];
BaseComponent = __decorateClass([
  withEventEmitter
], BaseComponent);
export {
  BaseComponent,
  SKELETON
};
